import React, { useContext, useEffect } from 'react';
import { Components } from './styled';
import useModalState from '../../../hooks/useModalState';
import ProjectTableModal from '../../ProjectTableModal';
import { modalConfigs } from '../../ProjectTableModal/constants';
import { Lesson } from '../../../api/types/lesson';
import { ProjectTableDataType } from '../../ProjectTable/types';
import { LARGE_PROJECT_MODAL_WIDTH } from '../../../utils/styled/dimensions';
import { AppSettingsContext } from '../../../providers/AppSettingsProvider/context';
import ProjectPicker from '../../ProjectPicker';
import ProjectSearchDropdown from '../../ProjectSearchDropdown';
import useCustomizedDropdown from '../../../hooks/useCustomizedDropdown';

const SelectLesson = ({
  isModalOpen,
  initialSelectedLessons,
  onModalClose,
  onSelectLesson,
}: {
  isModalOpen: boolean;
  initialSelectedLessons?: Lesson[];
  onModalClose: () => void;
  onSelectLesson: (lesson: Lesson[]) => void;
}) => {
  const { categories, pillarTypes, pillarExpertises } = useContext(AppSettingsContext);

  useEffect(() => {
    if (isModalOpen) {
      selectLessonProps.open(true);
    }
  }, [isModalOpen]);

  const selectLessonProps = useModalState<boolean>();

  const { props: pillarTypeProps } = useCustomizedDropdown({
    possibleValues: pillarTypes,
    singleSelect: true,
    customType: 'pillarType',
  });
  const { props: pillarExpertiseProps } = useCustomizedDropdown({
    possibleValues: pillarExpertises,
    singleSelect: true,
    customType: 'pillarExpertise',
  });
  const { props: categoryProps } = useCustomizedDropdown({
    possibleValues: categories,
    singleSelect: true,
  });

  const onSelectLessons = async (data: ProjectTableDataType | string[]) => {
    if (data && Array.isArray(data)) {
      onSelectLesson(data as Lesson[]);
    }
    onModalClose();
    selectLessonProps.onModalClose();
  };

  return (
    <ProjectTableModal
      modalConfig={modalConfigs.selectLessons({
        category: categoryProps.selectedItems?.[0]?.value,
        pillarType: pillarTypeProps.selectedItems?.[0]?.value,
        pillarExpertise: pillarExpertiseProps.selectedItems?.[0]?.value,
      })}
      {...selectLessonProps}
      keepSelectedOrder
      onModalClose={() => {
        onModalClose();
        selectLessonProps.onModalClose();
      }}
      onModalSubmit={onSelectLessons}
      // singleSelectionOnly
      modalTitle={'Select lessons'}
      modalWidth={LARGE_PROJECT_MODAL_WIDTH}
      sortingModel={{ field: 'publishedAt', sort: 'desc' }}
      initialSelectedRows={initialSelectedLessons}
      tableSearchChildren={
        <Components.SearchBarChildrenWrapper>
          <Components.SearchBarSeparator />
          <Components.FiltersWrapper>
            <ProjectPicker dropdownProps={pillarTypeProps} notSetText={'Pillar type'} />
            <ProjectSearchDropdown {...pillarTypeProps} />
            <ProjectPicker dropdownProps={pillarExpertiseProps} notSetText={'Pillar expertise'} />
            <ProjectSearchDropdown {...pillarExpertiseProps} />
            <ProjectPicker dropdownProps={categoryProps} notSetText={'Category'} />
            <ProjectSearchDropdown {...categoryProps} />
          </Components.FiltersWrapper>
        </Components.SearchBarChildrenWrapper>
      }
    />
  );
};

export default SelectLesson;
